module.exports = __webpack_public_path__ + "img/lyon02.d70fd0fa.jpg";